/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
import MoserObjectUtils from './MoserObjectUtils';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // propertyOverrideForPropertyType

/**
 * generic properties. <p>Java class for propertyType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="propertyType"&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="name" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="value" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class PropertyType extends MoserObject{

	name = null;

	value = null;



	/**
	 * Gets the value of the name property.
	 * @return {String} possible object is {@link String}
	 */
	getName() {
		return this.name;
	}

	/**
	 * Sets the value of the name property.
	 * @param {String} value allowed object is {@link String}
	 */
	setName(value) {
		var oldValue = this.name;
		this.name = value;
		this._setAndNotify(5, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the value property.
	 * @return {String} possible object is {@link String}
	 */
	getValue() {
		return this.value;
	}

	/**
	 * Sets the value of the value property.
	 * @param {String} value allowed object is {@link String}
	 */
	setValue(value) {
		var oldValue = this.value;
		this.value = value;
		this._setAndNotify(35, oldValue, value, false, false);
		MoserObjectUtils.propertyOverrideForPropertyType(this.getParent(), this);
	}

	/**
	 * Creates a new instance of <code>PropertyType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> PropertyType</code> object from.
	 * @return {PropertyType} an object of type <code>PropertyType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createPropertyType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "PropertyType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 5, "name", null));
		featureList.push(this.createFeature(false, false, false, 35, "value", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 5:
			this.setName((value));
			break;
		case 35:
			this.setValue((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 5:
			return this.getName();
		case 35:
			return this.getValue();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 5:
			return this.getName();
		case 35:
			return this.getValue();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/PropertyType.js